import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTypeManagerComponent} from './document-types.component'
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
    {
        path: '',
        component: DocumentTypeManagerComponent,
        canActivate: [MsalGuard],
        canActivateChild: [MsalGuard],
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    }

];

@NgModule({
    imports: [
      CommonModule,
      RouterModule.forChild(routes)
    ]
})
export class DocumentTypeManagerRoutingModule { }
